var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraIndoorExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ePA6KJGTlg91",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,0h24v24h-24L0,0Z",
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.337251-1.286426)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,9L12,3L7.54844,6.359148L12,11h-3L2.870645,4.599148L1.174708,5.949045L4,9v12h12l4.405322,3.550492l1.590562-2.08851L20.109998,21M14,16.407627v0c0,.55-.45.592373-1,.592373h-4c-.55,0-1-.45-1-1v-4c0-.55.45-1,1-1h4c.55,0,1,.45,1,1v1l2-1.06v3.227703l4.085182,3.041756L20.109998,21"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIndoorExit);
export default __webpack_public_path__ + "static/media/camera_indoor_exit.5ea1443f42136787b3909f201aed128a.svg";
export { ForwardRef as ReactComponent };